export const taskPriorityOptions = [
    { value: 'urgent', label: 'Urgent' },
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' }
];

export const leaveOptions = [
    { label: "Sick Leave", value: "SL" },
    { label: "Earned Leave", value: "EL" },
    { label: "Casual Leave", value: "CL" },
    { label: "Comp Off", value: "COFF" },
    { label: "Early Punch Out Leave", value: "EPOL" },
];

export const ResourceTypeOptions = [
    { value: 'superAdmin', label: 'Super Admin' },
    { value: 'admin', label: 'Admin' },
    { value: 'humanResource', label: 'HR' },
    { value: 'manager', label: 'Manager' },
    { value: 'teamlead', label: 'TeamLead' },
    { value: 'employee', label: 'Employee' },
    { value: 'intern', label: 'Intern' },
    { value: 'contractual', label: 'Contractual' }
]